<template>
    <div class="player-card" :class="{ 'needs-assessment': needsAssessment, 'injury-risk': player.injuryRiskFlag }">
        <div class="card-header">
            <img v-if="player.userImage" :src="getImgUrl(player.userImage)" :alt="player.playerName" class="avatar" />
            <div v-else class="avatar-placeholder">{{ getInitials(player.playerName) }}</div>
            <div class="player-info">
                <span class="name">{{ player.playerName }}</span>
                <span class="position">{{ player.position || 'No position' }}</span>
            </div>
            <span v-if="player.injuryRiskFlag" class="risk-indicator" title="Elevated injury risk">
                <i class="bi bi-exclamation-triangle-fill text-danger"></i>
            </span>
        </div>
        <div class="card-body">
            <div class="stat" v-if="!needsAssessment">
                <label>Bio Age</label>
                <span>{{ formatNum(player.bioAge) || '-' }}</span>
            </div>
            <div class="stat" v-if="!needsAssessment">
                <label>%PAH</label>
                <span>{{ formatNum(player.percentPAH) || '-' }}%</span>
            </div>
            <div class="stat" v-if="formatNum(player.growthVelocity)">
                <label>Growth</label>
                <span :class="{ 'text-danger': parseFloat(player.growthVelocity) > 6 }">
                    {{ formatNum(player.growthVelocity) }} cm/yr
                </span>
            </div>
            <div v-if="needsAssessment" class="assess-prompt">
                <i class="bi bi-clipboard-plus"></i>
                <span>Click to assess</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PlayerMaturityCard",
    props: {
        player: {
            type: Object,
            required: true
        },
        needsAssessment: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        getInitials(name) {
            if (!name) return '?';
            return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
        },
        formatNum(value) {
            if (value === null || value === undefined || value === '') return null;
            const num = parseFloat(value);
            return isNaN(num) ? null : num.toFixed(1);
        },
        getImgUrl(pic) {
            return pic !== undefined && pic !== "" ? `/images/${pic}` : "";
        },
    }
};
</script>

<style scoped>
.player-card {
    background: white;
    border-radius: 10px;
    padding: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid #e0e0e0;
}

.player-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.player-card.needs-assessment {
    border-style: dashed;
    border-color: #9e9e9e;
    background: #fafafa;
}

.player-card.injury-risk {
    border-color: #ef5350;
    background: #ffebee;
}

.card-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
}

.avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
}

.avatar-placeholder {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #e0e0e0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    color: #616161;
}

.player-info {
    flex: 1;
    min-width: 0;
}

.player-info .name {
    display: block;
    font-weight: 600;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.player-info .position {
    display: block;
    font-size: 12px;
    color: #757575;
}

.risk-indicator {
    font-size: 16px;
}

.card-body {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.stat {
    flex: 1;
    min-width: 60px;
    text-align: center;
    padding: 6px;
    background: #f5f5f5;
    border-radius: 6px;
}

.stat label {
    display: block;
    font-size: 10px;
    color: #757575;
    text-transform: uppercase;
    margin-bottom: 2px;
}

.stat span {
    font-size: 14px;
    font-weight: 600;
}

.assess-prompt {
    width: 100%;
    text-align: center;
    padding: 12px;
    color: #757575;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.assess-prompt i {
    font-size: 18px;
}
</style>
